import axios from 'axios';

export default (getOptions) => ({
    Mailer: async (params) => axios.post('/api/contact/pub/mailer', params, getOptions()),
});
